import { Component, OnInit } from '@angular/core';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-install-pwa',
  templateUrl: './install-pwa.component.html',
  styleUrls: ['./install-pwa.component.scss']
})
export class InstallPwaComponent implements OnInit {
  deferredPrompt: any = null;
  showInstallButton = false;
  isIOS = false;
  isSafariDesktop = false;
  isInStandaloneMode = false;

  ngOnInit(): void {
    (window as any).AddToHomeScreenInstance = (window as any).AddToHomeScreen(
      {
        appName: 'Mesa de Ayuda',
        appNameDisplay: 'standalone',                 // Si se establece como 'standalone' (valor por defecto), el nombre de la app
                                                      // se mostrará por separado, debajo del encabezado "Install App".
                                                      // Si se establece como 'inline', el nombre de la app se mostrará en una sola
                                                      // línea, como por ejemplo: "Install MyApp".
                                                      // Opcional. Valor por defecto: 'standalone'
        appIconUrl: 'assets/icons/icon-192x192.png',
        assetUrl: 'assets/images/imgIconos/',
        maxModalDisplayCount: -1,                     // Si se define, el modal solo se mostrará esta cantidad de veces.
                                                      // [Opcional] Valor por defecto: -1 (sin límite).
                                                      // (Para depuración: usar this.clearModalDisplayCount() para reiniciar el contador)
        displayOptions:{ showMobile: true, showTablet: true, showDesktop: true },
        allowClose: true,                             // Permite que el usuario cierre el modal tocando fuera de él.
                                                      // [Opcional. Valor por defecto: true]
        showArrow: true,                              // Muestra la flecha animada (rebotando) en el modal.
                                                      // [Opcional. Valor por defecto: true]
                                                      // (Altamente recomendado dejarlo en true ya que aumenta considerablemente
                                                      // la tasa de instalación)
      }
    );

    console.log('[PWA] Componente cargado');

    if (!environment.serviceWorker) {
      console.warn('[PWA] No habilitado en environment');
      return;
    }

    this.isIOS = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase()) ||
              (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);

    this.isSafariDesktop = /^((?!chrome|android).)*safari/i.test(navigator.userAgent) && !this.isIOS;
    
    this.isInStandaloneMode = ('standalone' in window.navigator) && (window.navigator as any).standalone;
    
    window.addEventListener('beforeinstallprompt', (event: any) => {
      event.preventDefault();
      this.deferredPrompt = event;
      this.showInstallButton = true;
    });
    
    if ((this.isIOS || this.isSafariDesktop) && !this.isInStandaloneMode) {
      this.showInstallButton = true;
    }

    window.addEventListener('appinstalled', () => {
      this.showInstallButton = false;
    });
  }

  instalarPWA(
  ) : void
  {
    if (this.deferredPrompt)
    {
      this.deferredPrompt.prompt();
      this.deferredPrompt.userChoice.then(() => {
        this.deferredPrompt = null;
        this.showInstallButton = false;
      });
    }
    else if ((this.isIOS || this.isSafariDesktop) && !this.isInStandaloneMode)
    {
      setTimeout(() => {
        (window as any).AddToHomeScreenInstance.show();
      }, 50);
    }
  }
}